import FiltersLabel from './FiltersLabel';

export default FiltersLabel;
